import { put, takeLatest } from "redux-saga/effects";
import { getMyQuestionnaire } from "src/redux/actions";
import { mapError } from "../../../../helpers/error";
import { IGetMyQuestionnaireAction } from "../../types";
import { SagaIterator } from "@redux-saga/core";
import { IQuestionnaire } from "src/common/types";

type FetchMyQuestionnaire = SagaIterator | Promise<IQuestionnaire>;

export function* fetchMyQuestionnaire({
  payload: { questionnaireId, lng }
}: IGetMyQuestionnaireAction): FetchMyQuestionnaire {
  try {
    const questionnaire = yield getMyQuestionnaire(questionnaireId, lng);
    yield put({
      payload: questionnaire,
      type: "GET_MY_QUESTIONNAIRE_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      payload: {
        e: mapError(e)
      },
      type: "GET_MY_QUESTIONNAIRE_REJECTED"
    });
  }
}

export default function* myQuestionnaireWatcher() {
  yield takeLatest("GET_MY_QUESTIONNAIRE", fetchMyQuestionnaire);
  yield takeLatest("REFETCH_MY_QUESTIONNAIRE", fetchMyQuestionnaire);
}
